import { fetch } from 'whatwg-fetch'
import logger from '../utils/logger.mjs';

const requiresEmployeeToken = async (uuid, employee, isMockMode) => {
  const authSource = window.sessionStorage.getItem('authSource');
  if (authSource !== 'salesforce')
    return null;

  logger.info('Attempting to fetch employee token data from Commerce SF Rest Service');
  try {

    if(isMockMode) {
      return "12435_fakeToken";
    } else if (uuid) {
      
      let requestBody = `<lead>` + `<uuid>${uuid}</uuid>`;
      requestBody += `<employeeInfo>`+
        `<id>${employee?.id}</id>`+
        `<employeeId>${employee?.employeeId}</employeeId>`+
        `<phone>${employee?.phone}</phone>`+
        `<email>${employee?.email}</email>`+
        `<firstName>${employee?.firstName}</firstName>`+
        `<lastName>${employee?.lastName}</lastName>`+
        `</employeeInfo>` +
        `</lead>`;
      const response = await fetch('/commerce/salesforce', {
        method: 'POST',
        headers: {'Content-Type': 'text/xml'},
        body: requestBody
      });
      const jsonResponse = await response.json();
      return jsonResponse && jsonResponse?.employeeRefreshToken ? jsonResponse.employeeRefreshToken : '';
    } else {
      logger.error('Unable to fetch employee token, no uuid');
      return '';
    }
  } catch (ex) {
    logger.error('Failed to fetch token from Salesforce Rest Service', ex);
  }

};

export default requiresEmployeeToken;
